import {AddressSearchResultsData} from "../../common/candidateAddresses.slice";
import {APUtils} from "./ap.util";

const formatParcel = (parcel: AddressSearchResultsData) => {
  return {
    key: parcel.GNAF_PID,
    laiskey: parcel.LAIS_KEY,
    latitude: parcel.LATITUDE,
    longitude: parcel.LONGITUDE,
    title: APSearchUtils.formatTitle (parcel),
    description: APSearchUtils.formatDescription(parcel)
  }
}

const getResults = (parcels: AddressSearchResultsData[]) => {
  if (parcels) {
    return parcels.map(parcel => formatParcel(parcel))
  }
}

const getResultsMatching = (parcels: AddressSearchResultsData[], searchType: string) => {
  return parcels
      .filter ( p => p.SEARCH_TYPE === searchType)
      .map(parcel => formatParcel(parcel))
}

const formatTitle = (parcel: AddressSearchResultsData) => {
  if (parcel.SEARCH_TYPE === 'PLACENAMES')
  {
    return parcel.Result
  }
  return parcel.SearchTerm
}

const formatDescription = (parcel: AddressSearchResultsData) => {
  if (parcel.SEARCH_TYPE === 'PLACENAMES')
  {
    return parcel.Result
  }

  return ""
}

export const APSearchUtils = {
  getResults,
  getResultsMatching,
  formatDescription,
  formatTitle,
}